// Copyright (c) 2020-2021 Visual Intelligence LP. All rights reserved.
//
export interface ValidateInfoItem {
  amount: number;
  fields: Array<{ amount: number; fields: Array<string> }>;
}

interface ValidateInfo {
  [key: string]: ValidateInfoItem;
}

export interface DataImportDTO extends ValidateInfo {
  records: ValidateInfoItem;
}

export class DataImport {
  records: ValidateInfoItem;

  constructor(dto: DataImportDTO) {
    this.update(dto);
  }

  get asJson(): DataImportDTO {
    return {
      records: this.records
    };
  }

  update(newData: Partial<DataImportDTO>): DataImportDTO {
    const allData = { ...this.asJson, ...newData };

    Object.assign(this, allData);

    return this.asJson;
  }
}